import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerChopSignService } from '../../service/customer-chop-sign.service';
import { Input } from '@angular/core';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { HttpEventType } from '@angular/common/http';
import { FileUpload } from 'primeng/fileupload';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-customer-chop-sign',
  templateUrl: './customer-chop-sign.component.html',
  styleUrls: ['./customer-chop-sign.component.scss']
})
export class CustomerChopSignComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.CusomterChopSign;
  currentLang: string = this.laasSetting.language;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('op') op!: OverlayPanel;
  readonly preferenceKey: string;
  isSearchFormOpen:boolean;
  searchForm!: FormGroup;
  searchParams: any;
  chopSignResults: any[];
  columns: any[];
  selectedCols: any[];
  isLoading: boolean;
  showUpload: boolean;
  submitted: boolean;

  uploadParams: any;

  updateParmas: any;

  constructor(
    injector:Injector,
    private fb: FormBuilder,
    private customerChopSignService: CustomerChopSignService
  ) {
    super(injector);
    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.showUpload = false;
    this.preferenceKey = UserPreferenceConstants.CustomerChopSignSearch;
    this.chopSignResults = [];
    this.updateParmas = {};
    this.uploadParams = {};
    this.submitted = false;
    this.searchParams = {
      doNo:""
    };
    this.searchForm = this.fb.group({
      doNo: ["", Validators.required]
    });

    this.columns = [
      { field: 'seqNo', header: 'CompanyStampMaintenance.MainTable.FileKey' },
      { field: 'fileName', header: 'CompanyStampMaintenance.MainTable.FileName' },
      { field: 'siteUseId', header: 'CompanyStampMaintenance.MainTable.SiteId' },
      { field: 'effectiveStartDate', header: 'CompanyStampMaintenance.MainTable.FromTime', dataType: 'date' },
      { field: 'effectiveEndDate', header: 'CompanyStampMaintenance.MainTable.EndTime', dataType: 'date' },
      { field: 'sn', header: 'CompanyStampMaintenance.MainTable.Photo' },
      { field: 'createUser', header: 'CompanyStampMaintenance.MainTable.CreateBy' },
      { field: 'createDt', header: 'CompanyStampMaintenance.MainTable.CreateDate', dataType: 'date' }

    ];

    this.selectedCols = this.columns;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
  }

  searchClickBtn(event: any): void{
    this.submitted = true;

    if (this.searchForm.invalid) {
      //請檢查是否有必填欄位尚未填寫
      this.translateService.get('CompanyStampMaintenance.Alert.CheckRequiredFields')
      .subscribe({
        next: result => {
          this.toastService.warn(result);
        }
      });
      return;
    }

    this.isLoading = true;

    this.chopSignResults = [];

    this.customerChopSignService.getCustomerChopsign(this.searchParams.doNo).subscribe({
      next: result => {
        this.chopSignResults = result;
        this.isLoading = false;
      }
    })
  }

  openOverLay(event: any, rowData: any): void{
    this.updateParmas.minDate = new Date(rowData.effectiveStartDate);
    this.updateParmas.seqNo = rowData.seqNo;
    this.updateParmas.userId = this.userProfile.loginAccount;
    this.op.toggle(event);
  }

  saveEffectiveEndDate(event: any): void{
    this.updateParmas.effectiveEndDate = isNullOrEmpty(this.updateParmas.effectiveEndDateTimeZone) ? null : new Date(this.updateParmas.effectiveEndDateTimeZone).toISOString();
    this.customerChopSignService.updateEffectiveEndDate(this.updateParmas).subscribe({
      next: result => {
        this.searchClickBtn(null);
        this.updateParmas = {};
        this.op.hide();
      }
    })
  }

  uploadClickBtn(event: any): void{
    this.showUpload = true;
  }

  resetBtnClick(event: any): void {
    this.searchForm.reset();
  }

  getImgUrl(sn: string): string {
    return this.customerChopSignService.getImgUrl(sn);
  }

  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  fileUploader(event: any): void{
    this.loader.show();

    var uploadObj = {
      effectiveStartDate: isNullOrEmpty(
        this.uploadParams.effectiveStartDateTimeZone
      )
        ? null
        : new Date(this.uploadParams.effectiveStartDateTimeZone).toISOString(),
      effectiveEndDate: isNullOrEmpty(
        this.uploadParams.effectiveEndDateTimeZone
      )
        ? null
        : new Date(this.uploadParams.effectiveEndDateTimeZone).toISOString(),
      forceUpload: this.uploadParams.forceUpload,
      userId: this.userProfile.loginAccount,
    };
    console.log(event.files[0]);
    this.customerChopSignService.uploadCustomerChopSign(event.files[0], uploadObj).subscribe({
      next: rsp => {

        if (rsp.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * rsp.loaded / rsp.total);
          this.fileUpload.progress = percentDone;
        }
        if (rsp.type === HttpEventType.Response) {
          if (rsp.status == 200) {
            //上傳成功
            this.translateService.get('CompanyStampMaintenance.Success.UploadSuccess')
            .subscribe({
              next: result => {
                this.toastService.success(result, false);
              }
            });
          }
        }
      },
      error: rsp => {
        console.log(rsp);
        this.toastErrorMessage(rsp.error);
        this.loader.hide();
      },
      complete: () => {
        this.uploadParams = {};
        this.showUpload = false;
        this.loader.hide();
      }
    });
  }

}
